module.exports = __webpack_public_path__ + "static/media/Shopeepay.a0841911.svg";